<template>
  <v-dialog v-model="dialog" persistent width="950px">
    <v-card>
      <v-card-title class="headline">
        <v-icon>check</v-icon> Aprobar permiso 33333
        <v-spacer></v-spacer>
        <v-btn icon @click="close()">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-0">
        <v-container grid-list-md class="pt-0">
          <v-layout row wrap>
            <v-flex xs12>
              <h3><strong>Número:</strong> {{ permiso.numero }}</h3>
            </v-flex>
            <v-flex xs12>
              <h3><strong>Funcionario:</strong> {{ permiso.nombres }}</h3>
            </v-flex>
            <v-flex xs12>
              <h3>
                <strong>Tipo de papeleta:</strong> {{ permiso.tipo_permiso }}
              </h3>
            </v-flex>
            <!-- <v-flex xs12 v-if="permiso.id_tipo_permiso == 8">
              <h3>
                <strong>Lugar de atencion:</strong> {{ permiso.lugar_atencion }}
              </h3>
            </v-flex> -->
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 87">
              <h3><strong>Lugar de comisión :</strong> {{ permiso.lugar }}</h3>
            </v-flex>
            <v-flex
              xs12
              v-if="
                permiso.id_tipo_permiso == 87 ||
                  permiso.id_tipo_permiso == 96 ||
                  permiso.id_tipo_permiso == 101
              "
            >
              <h3><strong>Motivo:</strong> {{ permiso.permiso.motivo }}</h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 90">
              <h3>
                <strong>Tipo de baja:</strong> {{ permiso.permiso.motivo }}
              </h3>
            </v-flex>
            <v-flex xs12 v-if="permiso.id_tipo_permiso == 44">
              <h3>
                <strong>Condición o estado crítico de salud :</strong>
                {{ permiso.permiso.motivo }}
              </h3>
            </v-flex>
          </v-layout>
          <v-layout row wrap>
            <v-flex xs12>
              <h3><strong>Detalles de papeleta:</strong></h3>
            </v-flex>
          </v-layout>
          <!-- permisos justificativo caja nro 8 -->
          <v-layout v-if="permiso.id_tipo_permiso == 8">
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1"
                hide-actions
                :headers="headers_caja"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_desde, "HH:mm")
                        .subtract("00:20")
                        .format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>

                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.hora_hasta, "HH:mm")
                        .add("00:20")
                        .format("HH:mm")
                    }}
                  </td>
                  <td class="text-xs-center">
                    {{
                      $moment(props.item.total_horas, "HH:mm").format("HH:mm")
                    }}
                  </td>
                  <td
                    v-if="permiso.id_tipo_permiso == 24"
                    class="text-xs-center"
                  >
                    {{ props.item.total_dias }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias decimales -->
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 14 ||
                (permiso.id_tipo_permiso >= 98 &&
                  permiso.id_tipo_permiso <= 101) ||
                permiso.id_tipo_permiso == 89 ||
                permiso.id_tipo_permiso == 18
            "
          >
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1"
                hide-actions
                :headers="headers_dias_decimales"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por dias completos-->
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 6 ||
                permiso.id_tipo_permiso == 44 ||
                permiso.id_tipo_permiso == 95 ||
                permiso.id_tipo_permiso == 61 ||
                permiso.id_tipo_permiso == 12 ||
                permiso.id_tipo_permiso == 90
            "
          >
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1"
                hide-actions
                :headers="headers_dias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos por horas -->
          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1"
                hide-actions
                :headers="headers_horas"
                v-if="
                  permiso.id_tipo_permiso == 87 ||
                    permiso.id_tipo_permiso == 96 ||
                    permiso.id_tipo_permiso == 88 ||
                    (permiso.id_tipo_permiso >= 37 &&
                      permiso.id_tipo_permiso <= 43)
                "
              >
                >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>

                  <td class="text-xs-center">
                    {{
                      $moment(props.item.total_horas, "HH:mm").format("HH:mm")
                    }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos 94 formulario de registro de asistencias-->
          <v-layout v-if="permiso.id_tipo_permiso == 94">
            <v-flex xs12>
              <v-data-table
                :items="permiso_detalles2"
                class="elevation-1"
                hide-actions
                :headers="headers_registro_asistencias"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_salida }}
                  </td>
                  <td class="text-xs-center">
                    {{ props.item.fecha_hasta }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <!-- permisos nro 24 -->
          <v-layout>
            <v-flex>
              <!-- permiso nro 24 -->
              <v-data-table
                :items="permiso_detalles"
                class="elevation-1"
                hide-actions
                :headers="headers"
                v-if="permiso.id_tipo_permiso == '24'"
              >
                <template v-slot:items="props">
                  <td
                    class="text-xs-center"
                    v-if="permiso.id_tipo_permiso == '24'"
                  >
                    {{ props.item.fecha_desde }}
                  </td>
                  <td
                    class="text-xs-center"
                    v-if="permiso.id_tipo_permiso == '24'"
                  >
                    {{ props.item.fecha_hasta }}
                  </td>

                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <!--  total horas-->
                  <td
                    v-if="
                      (props.item.hora_desde == '08:30' ||
                        props.item.hora_desde == '08:00') &&
                        (props.item.hora_hasta == '12:00' ||
                          props.item.hora_hasta == '12:30')
                    "
                    class="text-xs-center"
                  >
                    4:00 - Solo mañana
                  </td>
                  <td
                    v-if="
                      (props.item.hora_desde == '12:30' ||
                        props.item.hora_desde == '12:00') &&
                        (props.item.hora_hasta == '16:30' ||
                          props.item.hora_hasta == '16:00')
                    "
                    class="text-xs-center"
                  >
                    4:00 - Solo tarde
                  </td>
                  <td
                    v-if="
                      (props.item.hora_desde == '08:30' ||
                        props.item.hora_desde == '08:00') &&
                        (props.item.hora_hasta == '16:00' ||
                          props.item.hora_hasta == '16:30')
                    "
                    class="text-xs-center"
                  >
                    8:00 - Todo el dìa
                  </td>
                  <td class="text-xs-center">{{ props.item.total_dias }}</td>
                  <td class="text-xs-center">
                    {{ props.item.estado_detalle }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>

          <!--COMPENSACION -->
          <h3
            v-if="
              permiso.id_tipo_permiso == 88 ||
                (permiso.id_tipo_permiso == 96 &&
                  permiso.compensa_tolerancia == 1)
            "
          >
            <strong>Detalles compensacion</strong>
          </h3>
          <v-layout
            v-if="
              permiso.id_tipo_permiso == 88 ||
                (permiso.id_tipo_permiso == 96 &&
                  permiso.compensa_tolerancia == 1)
            "
          >
            <v-flex xs12>
              <v-data-table
                :items="permiso_compensacion"
                class="elevation-1"
                hide-actions
                :headers="headers2"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_desde).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">
                    {{ $moment(props.item.fecha_hasta).format("DD/MM/YYYY") }}
                  </td>
                  <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                  <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                  <td class="text-xs-center">
                    {{ props.item.diferencia_horas }}
                  </td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
          <v-layout class="pa-2">
            <v-flex xs12>
              <h4
                v-if="
                  permiso.id_tipo_permiso == 88 ||
                    (permiso.id_tipo_permiso == 96 &&
                      permiso.compensa_tolerancia == 1)
                "
              >
                <strong>Total horas: {{ total_horas_acomuladas }}</strong>
              </h4>
            </v-flex>
          </v-layout>

          <!-- SEGUIMIENTO -->

          <v-layout class="text-xs-center">
            <h2><strong>Seguimiento de papeleta</strong></h2>
          </v-layout>

          <v-layout>
            <v-flex xs12>
              <v-data-table
                :items="detalle_seguimiento"
                class="elevation-1"
                hide-actions
                :headers="headers_detalle"
              >
                <template v-slot:items="props">
                  <td class="text-xs-center">
                    {{ props.item.fecha_registro }}
                  </td>
                  <td class="text-xs-center">{{ props.item.estado }}</td>
                  <td class="text-xs-center">{{ props.item.usuario }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="secundary" @click.prevent="close()" :loading="loading"
          ><v-icon>check</v-icon>
          Cancelar
        </v-btn>
        <v-btn
          color="success"
          @click.prevent="apruebaRechazaPermiso(permiso, 77)"
          :loading="loading"
          ><v-icon>check</v-icon>
          Aprobar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import validate from "@/common/mixins/validate";
import SeguimientoDetalle from "../components/SeguimientoDetalle";

export default {
  components: {
    SeguimientoDetalle
  },
  mixins: [validate],
  props: ["item"],
  async mounted() {
    this.$bus.$on("openDialogAprobarPermisoRRHH", item => {
      this.permiso = item;
      (this.permiso_detalles2 = [
        {
          fecha_salida: this.permiso.fecha_desde,
          fecha_hasta: this.permiso.fecha_retorno,
          hora_desde: this.permiso.hora_desde,
          hora_hasta: this.permiso.hora_hasta,
          total_horas: this.permiso.horas_permiso,
          total_dias: this.permiso.nro_dias
        }
      ]),
        //console.log(this.$moment(this.permiso_detalles2.hora_desde, "HH:mm").add(this.$moment(this.permiso_detalles2.hora_desde, "HH:mm")))
        this.total_horas();
      this.getDetallePermiso(this.permiso.id_permiso);
      this.verPermisosCompensacion(this.permiso.id_permiso);
      this.getDetalleSeguimiemto(this.permiso.id_permiso);
      this.dialog = true;
    });
  },
  data() {
    return {
      dialog: false,
      permiso: {
        rechazo: ""
      },
      permiso_compensacion: [],
      total_horas_acomuladas: 0,
      permiso_detalles: [],
      permiso_detalles2: [],
      detalle_seguimiento: [],
      loading: false,
      headers2: [
        {
          text: "Fecha desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias_decimales: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_caja: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "tolerancia",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },

        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Tolerancia hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_horas: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Total Horas",
          sortable: false,
          align: "center"
        }
      ],
      headers_dias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },

        {
          text: "Total Dias",
          sortable: false,
          align: "center"
        }
      ],
      headers_registro_asistencias: [
        {
          text: "Fecha salida",
          sortable: false,
          align: "center"
        },
        {
          text: "Fecha hasta",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora desde",
          sortable: false,
          align: "center"
        },
        {
          text: "Hora hasta",
          sortable: false,
          align: "center"
        }
      ],
      headers_detalle: [
        {
          text: "Fecha registro",
          sortable: false,
          align: "center"
        },
        {
          text: "Estado",
          sortable: false,
          align: "center"
        },
        {
          text: "Usuario",
          sortable: false,
          align: "center"
        }
      ],
      horas_solicitadas: 0
    };
  },
  methods: {
    async verPermisosCompensacion(id_permiso) {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"select * from control.fn_permiso_compensa_datos(${id_permiso}) AS datos"){
                                  respuesta
                                }
                            }
                            `
        });
        if (respuesta.runQuery.respuesta.length > 0) {
          this.permiso_compensacion = respuesta.runQuery.respuesta;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async total_horas() {
      try {
        let respuesta = await this.$service.graphql({
          query: `
                query{
                  runQuery(consulta:"select control.fn_total_horas_compensacion(${this.permiso.id_permiso})"){
                    respuesta
                  }
                }	

              `
        });
        if (
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion == null ||
          respuesta.runQuery.respuesta[0].fn_total_horas_compensacion ==
            undefined
        ) {
          this.total_horas_acomuladas = 0;
        } else {
        }
        let resp = respuesta.runQuery.respuesta[0].fn_total_horas_compensacion;
        this.total_horas_acomuladas = resp;
      } catch (error) {
        console.log(error);
      }
    },
    close() {
      this.dialog = false;
      this.permiso = {
        permiso: {
          motivo: ""
        }
      };
      this.$bus.$emit("closeDialogAprobarRRHHPermiso");
    },
    /* aprobarRechazar(id_permiso, id_estado) {
      this.loading = true;
      this.$service
        .graphql({
          query: `
					query {
						apruebaControlPermiso(id_tipo_permiso: ${id_permiso}, id_estado: ${id_estado}, id_jefe: ${this.getUserId()}){
							mensaje
						}
					}
				`,
        })
        .then((response) => {
          if (response.apruebaControlPermiso.mensaje === "ok") {
            this.$message.success();
            this.$bus.$emit("closeDialog");
            this.close();
          } else {
            this.$message.error(response.apruebaControlPermiso.mensaje);
            this.close;
          }
        });
      this.loading = false;
    },*/
    sumar_horas(permiso_detalles) {
      if (this.permiso.id_permiso != 90) {
        let total = 0;
        permiso_detalles.forEach(item => {
          total +=
            this.$moment(item.fecha_hasta + " " + item.hora_hasta).diff(
              item.fecha_desde + " " + item.hora_desde,
              "minutes"
            ) / 60;
        });
        this.horas_solicitadas = total;
      }
    },
    getUserId() {
      const user = this.$storage.get("user");
      return user.id_persona;
    },
    async getDetallePermiso(id_permiso) {
      try {
        let res = await this.$service.graphql({
          query: `
			query{
            vDetallePermisos(id_permiso: ${id_permiso}){
              rows{
                id
                id_permiso
                fecha_desde
                fecha_hasta
                hora_desde
                hora_hasta
                total_dias
                total_horas
                
              }
            }
          }
          `
        });
        this.permiso_detalles = res.vDetallePermisos.rows;

        this.sumar_horas(this.permiso_detalles);
      } catch (error) {
        console.log(error);
      }
    },
    async getDetalleSeguimiemto(id) {
      try {
         let respuesta 
        let res 
        respuesta= await this.$service.graphql({
          query: `
                               query{
                                    runQuery(consulta:"SELECT * FROM control.v_seguimiento_detalle_historico vd where vd.id=(${id}) order by vd.id_seguimiento desc"){
                                  respuesta
                                }
                            }
                            `,
        });

        respuesta = respuesta.runQuery.respuesta;
        //obtener el nuevo seguimiento
         res = await this.$service.graphql({
          query: `
                query{
      			      vSeguimientoDetalles(id:${id}){
          			    rows{
						          fecha_registro
            			    estado
            			    usuario
                      jefe
                      id_estado
                      motivo
                      jefe
                      }
                  }
              }

          `,
        });
        res = res.vSeguimientoDetalles.rows;
        this.detalle_seguimiento = res.concat(respuesta);
      } catch (error) {
        console.log(error);
      }
    },
    async apruebaRechazaPermiso(permiso, id_estado) {
      const user = this.$storage.get("user");
      console.log("estado:", id_estado);
      let respuesta = "";
      if (this.permiso.id_tipo_permiso == 44) {
        try {
          console.log(user.id_persona);
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_ds3462(${permiso.id_permiso},${id_estado},${user.id},'')"){
                  respuesta
                }
              }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_ds3462;
          let resps2 = resp.split("|");
          let correcto = resps2[0];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resps2[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 96) {
        try {
          console.log(`
              query{
                runQuery(consulta:"select control.fn_aprueba_tolerancia(${permiso.id_permiso},${id_estado},${user.id},'${permiso.rechazo}')"){
                  respuesta
                }
              }
            `)
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_tolerancia(${permiso.id_permiso},${id_estado},${user.id},'${permiso.rechazo}')"){
                  respuesta
                }
              }
            `
          });
          //console.log(respuesta.runQuery.respuesta)
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_tolerancia;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 7) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 90) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_aprueba_permiso_rrhh_baja_medica(${permiso.id_permiso},${this.permiso.id_persona},${id_estado},'${user.id}','${permiso.rechazo}')"){
                  respuesta
                }
              }
            `
          });
          //console.log(respuesta.runQuery.respuesta)
          let resp =
            respuesta.runQuery.respuesta[0].fn_aprueba_permiso_rrhh_baja_medica;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 7) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 12) {
        try {
          respuesta = await this.$service.graphql({
            query: `
              query{
                
                  runQuery(consulta:"select control.fn_aprueba_rechaza_permiso_matrimonio(${permiso.id_permiso},'${id_estado}','${user.id}',${user.id_persona})"){
                  respuesta
                }
              }
            `
          });
          //console.log(respuesta.runQuery.respuesta)
          let resp =
            respuesta.runQuery.respuesta[0]
              .fn_aprueba_rechaza_permiso_matrimonio;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 7) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
          }
        } catch (error) {
          console.log(error);
        }
      }

      if (this.permiso.id_tipo_permiso == 95) {
        try {
          console.log(`
              query{
                
                  runQuery(consulta:"select control.fn_aprueba_rechaza_permiso_teletrabajo(${permiso.id_permiso},77,'${user.id}',${user.id_persona})"){
                  respuesta
                }
              }
            `)
          respuesta = await this.$service.graphql({
            query: `
              query{
                
                  runQuery(consulta:"select control.fn_aprueba_rechaza_permiso_teletrabajo(${permiso.id_permiso},77,'${user.id}',${user.id_persona})"){
                  respuesta
                }
              }
            `
          });
          //console.log(respuesta.runQuery.respuesta)
          let resp =
            respuesta.runQuery.respuesta[0]
              .fn_aprueba_rechaza_permiso_teletrabajo;
          let resps = resp.split("|");
          let correcto = resps[0];

          if (resps[0] == "1" && id_estado == 77) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Aprobar permiso cumpleaños p89
      if (this.permiso.id_tipo_permiso == 89) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},77,${user.id},${this.permiso.id_persona})"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Apribar permiso sin goce de haberes p18
      if (this.permiso.id_tipo_permiso == 18) {
        // SELECT control.fn_envia_permiso_sin_haber(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer)
        let consulta = `SELECT control.fn_envia_permiso_sin_haber(${permiso.id_permiso},${id_estado},${user.id},${this.permiso.id_persona})`;
        try {
          respuesta = await this.$service.graphql({
            query: `
                    query{
                        runQuery(consulta:"${consulta}"){
                        respuesta
                      }
                    }
                  `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_sin_haber;
          let resps = resp.split("|");
          if (resps[0] == "1" && id_estado == 7) {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          }
          if (resps[0] == "1" && id_estado == 16) {
            this.$confirm("El permiso fue rechazado", () => {});
            this.close();
          }

          if (resps[0] == "0") {
            this.$confirm(resps[1], () => {});
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Aprobar permiso asueto dia de la mujer p100
      if (this.permiso.id_tipo_permiso == 100) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},77,${user.id},${this.permiso.id_persona})"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Aprobar permiso asueto dia de la madre p99
      if (this.permiso.id_tipo_permiso == 99) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},77,${user.id},${this.permiso.id_persona})"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Aprobar permiso asueto dia del padre p98
      if (this.permiso.id_tipo_permiso == 98) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},77,${user.id},${this.permiso.id_persona})"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      // Aprobar permiso asueto otros p101
      if (this.permiso.id_tipo_permiso == 101) {
        // control.fn_envia_permiso_asueto(
        //   p_id_permiso integer,
        //   p_id_estado integer,
        //   p_id_funcionario integer,
        //   p_id_persona integer
        // )
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_envia_permiso_asueto(${permiso.id_permiso},77,${user.id},${this.permiso.id_persona})"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_envia_permiso_asueto;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }
      if (this.permiso.id_tipo_permiso == 8) {
        try {
          let respuesta = await this.$service.graphql({
            query: `
            query{
              runQuery(consulta:"select control.fn_aprueba_justifica_caja(${permiso.id_permiso},77,${user.id},'')"){
                respuesta
              }
            }
            `
          });
          let resp = respuesta.runQuery.respuesta[0].fn_aprueba_justifica_caja;
          resp = resp.split("|");
          let correcto = resp[0];
          let mensaje = resp[1];
          if (correcto == "1") {
            this.$confirm("El permiso fue aprobado", () => {});
            this.close();
          } else {
            this.$confirm(resp[1], () => {});
            this.close();
          }
        } catch (error) {
          console.log(error);
        }
      }

      this.close();
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/admin/permiso/dialogs/AprobarPermisoRRHH.vue